import axios from 'axios'

const apiBaseUrl = 'https://claudiademedio.com/back/wp-json/cdm/v2'
const apiWorkUrl = apiBaseUrl + '/work'

export default class PostService {
  getAllPosts() {
    return axios.get(apiWorkUrl)
  }
}